export interface IssuesReturnToNormalActivity{
    hasIssuesPreventingReturn: boolean,
    issuesDetails: string,
}

export const defaultIssuesReturnToNormalActivity: IssuesReturnToNormalActivity = {
    hasIssuesPreventingReturn: false,
    issuesDetails: ""
}